import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { GET_USER_IN_2N } from '../get-user';
import { useModal } from '../../../store/modals';
import { updateUserIn2nAPI } from './api';

export function useUpdateUserIn2n(user) {

  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutateAsync, mutate, isLoading, isSuccess, isError } = useMutation(
    (data) => updateUserIn2nAPI(user, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_USER_IN_2N, tenantId, user.Account.Email, user?.isSuspended]);
      },
      onError: (error) => {
        if (error.errorMessage === 'No pairing devices available for this user') {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'noPairingDevicesErrorMessage',
            },
          });
        } else if (error.errorMessage?.includes('format error')) {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'invalidRFIDtagErrorMessage',
            },
          });
        } else if (error.errorMessage?.includes('is already used') || error.errorMessage?.includes('cannot have 2 access cards')) {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'alreadyUsedRFIDtagErrorMessage',
            },
          });
        } else {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'genericErrorMessage',
            },
          });
        }
      },
    },
  );

  return {
    mutateAsync,
    mutate,
    isLoading,
    isSuccess,
    isError,
  };
}

